<template>
  <b-modal v-model="show" size="lg" @close="onCancel">
    <template v-slot:modal-title>
      <span v-text="$t('scheduler.import_csv')" />
    </template>
    <div class="container">
      <div class="panel panel-sm">
        <div class="panel-body">
          <div class="form-group">
            <label for="csv_file" class="control-label col-sm-3"
              >CSV file to import</label
            >
            <div class="col-sm-9">
              <input
                type="file"
                accept=".csv"
                id="csv_file"
                name="csv_file"
                class="form-control"
                @change="loadCSV($event)"
              />
            </div>
          </div>
          <div class="col-sm-offset-3 col-sm-9">
            <div class="checkbox-inline">
              <label for="header-rows">
                <input type="checkbox" id="header_rows" />
                File contains header row?
              </label>
            </div>
          </div>
          <div class="col-sm-offset-3 col-sm-9">
            <!-- <a href="#" class="btn btn-primary">Parse CSV</a> -->
            <table v-if="parse_csv">
              <thead>
                <tr>
                  <th
                    v-for="(item, id) in parse_header"
                    :key="id"
                    @click="sortBy(item)"
                    :class="{ active: sortKey == item }"
                  >
                    {{ item | capitalize }}
                    <span
                      class="arrow"
                      :class="sortOrders[item] > 0 ? 'asc' : 'dsc'"
                    >
                    </span>
                  </th>
                </tr>
              </thead>
              <tr v-for="(csv, idy) in parse_csv" :key="idy">
                <td v-for="(item, idx) in parse_header" :key="idx">
                  {{ csv[item] }}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <template v-slot:modal-footer class="bg-white">
      <b-button
        type="submit"
        class="mr-2"
        variant="primary"
        @click="onOk"
        :disabled="disableForm"
        >OK</b-button
      >
      <b-button
        class="btn btn-danger"
        v-text="$t('buttons.close')"
        @click="onCancel"
        :disabled="disableForm"
      ></b-button>
    </template>
  </b-modal>
</template>
<script>
import MessagesApi from "../../apis/MessagesApi";
import PharmaopsApi from "../../apis/PharmaopsApi";
import { useManageAttributes } from "../../stores/manage-attributes";
export default {
  computed: {
    pu_form() {
      return this.useManageAttributes.pu_form;
    },
    states() {
      return this.useManageAttributes.states;
    },
    errors() {
      return this.useManageAttributes.errors;
    },
    errorMessage() {
      return this.useManageAttributes.errorMessage;
    },
    hasErrors() {
      return this.useManageAttributes.hasErrors;
    },
    disableForm() {
      return this.useManageAttributes.disableForm;
    },
    disableCancel() {
      return this.useManageAttributes.disableCancel;
    },
    hasOriginalDataChanged() {
      return this.useManageAttributes.hasOriginalDataChanged;
    },
  },
  data() {
    return {
      csrf: null,
      route: null,
      method: "POST",
      show: false,
      resolve: null,
      reject: null,
      csv: null,
      channel_name: "",
      channel_fields: [],
      channel_entries: [],
      parse_header: [],
      parse_csv: [],
      sortOrders: {},
      sortKey: "",
      useManageAttributes: useManageAttributes(),
    };
  },
  filters: {
    capitalize: function (str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
  },
  created() {
    this.csrf = document.head.querySelector('meta[name="csrf-token"]').content;
  },
  methods: {
    sortBy: function (key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
    },
    csvJSON(csv) {
      let vm = this;
      let lines = csv.split("\n");
      let result = [];
      let headers = lines[0].split(",");
      vm.parse_header = lines[0].split(",");
      lines[0].split(",").forEach(function (key) {
        vm.sortOrders[key] = 1;
      });

      lines.map(function (line, indexLine) {
        if (indexLine < 1) return; // Jump header line

        let obj = {};
        let currentline = line.split(",");

        headers.map(function (header, indexHeader) {
          obj[header] = currentline[indexHeader];
        });

        result.push(obj);
      });

      result.pop(); // remove the last item because undefined values

      return result; // Javascript object
    },
    loadCSV(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createInput(files[0]);
    },
    createInput(file) {
      let promise = new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.onload = (e) => {
          resolve((this.fileinput = reader.result));
        };
        reader.readAsText(file);
      });

      promise.then(
        (result) => {
          /* handle a successful result */
          this.parse_csv = this.csvJSON(this.fileinput);
        },
        (error) => {
          /* handle an error */
          console.log(error);
        }
      );
    },
    open() {
      this.show = true;

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    onOk() {},
    hasError(field) {
      if (!this.pu_form[field] || this.pu_form[field].length == 0) {
        this.useManageAttributes.updateErrors({ [field]: true });
        return true;
      } else {
        this.useManageAttributes.updateErrors({ [field]: false });
        return false;
      }
    },
    saveMessageTemplate(payload) {
      // If Message Template already exists, just add it.
      if (this.existing_message_template) {
        this.addMessage(payload.result, this.pu_form.instanceId);
        return;
      }
      this.useManageAttributes.updateStates({
        saving_pu_form: true,
      });
      MessagesApi.create(payload.result, this.pu_form.instanceId)
        .then((r) => {
          this.useManageAttributes.updateStates({
            saving_pu_form: false,
          });
          this.addMessage(r.result, this.pu_form.instanceId);
        })
        .catch((e) => {
          let errorMessage = this.$t("pharmaops.update_failed");
          this.useManageAttributes.updateStates({
            saving_pu_form: false,
          });

          if (e.response && e.response.status == 412) {
            errorMessage = this.$t("commons.optimistic_lock");
            this.useManageAttributes.setErrorMessage(errorMessage);
            this.invalid = true;
          } else if (
            e.response &&
            (e.response.status == 400 || e.response.status == 409)
          ) {
            errorMessage = e.response.data.data.detail;
            this.useManageAttributes.setErrorMessage(errorMessage);
          }
          this.$toast.error("Error", errorMessage);
        });
    },
    addMessage(message, instanceId) {
      let autoReplies = {};
      let key = this.formatKey(message.id);
      autoReplies[key] = {
        actionIds: [],
        messageTemplateId: message.id,
      };

      let payload = {
        id: instanceId,
        attributes: {
          messageEngine: "pinpoint",
          message: {
            settings: {
              default: {
                autoReplies: autoReplies,
              },
            },
          },
        },
      };

      this.useManageAttributes.updateStates({
        adding_pu_form: true,
      });
      PharmaopsApi.addMessageTemplate(this.pu_form.instanceId, payload)
        .then((response) => {
          this.useManageAttributes.updateStates({
            adding_pu_form: false,
          });
          this.$toast.success(
            "Success",
            this.$t("pharmaops.mt_added_successfully")
          );
          this.useManageAttributes.updateStates({
            showAddedMessageTemplateSuccess: true,
            addedSuccess: true,
          });
          this.resolve(message);
          this.show = false;
        })
        .catch((e) => {
          this.useManageAttributes.updateStates({
            adding_pu_form: false,
          });
        });
    },
    formatKey(key) {
      key = key.endsWith("-message") ? key.slice(0, -8) : key;
      return key.toUpperCase();
    },
    onCancel() {
      this.resolve(false);
      this.show = false;
    },
  },
};
</script>
